import StaffDirectoryPage from '../../../components/admin/staff/StaffDirectoryPage'

export default function StaffDirectory() {
  return <StaffDirectoryPage />
}
